import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import CopiedText from '@common/clipboard/copied-text/copied-text';
import { assignTestId } from '@common/infra/tests/assign-test-id';
export function LicenseEventChecksum({ event }) {
    return (_jsxs("div", { children: [_jsx(Text, { info: true, size: "s", ...assignTestId('algorithm'), children: event.checksumAlgorithm }), ' ', _jsx(CopiedText, { text: event.checksum, ...assignTestId('checksum') })] }));
}
